// extracted by mini-css-extract-plugin
export var projectCard = "project-card-module--projectCard--Q2zbx";
export var projectCardImage = "project-card-module--projectCardImage--UBLli";
export var projectCardImagehalf = "project-card-module--projectCardImagehalf--nxHu0";
export var projectCardContent = "project-card-module--projectCardContent--SQdN8";
export var projectCardContentReadMore = "project-card-module--projectCardContentReadMore--LFWcW";
export var projectCardContentReadMoreArrow = "project-card-module--projectCardContentReadMoreArrow--OlImz";
export var projectCardLink = "project-card-module--projectCardLink--+PixT";